import { rejected, resolved } from 'store/createAction';
import { GET_MESSAGES, SEND_REPLY_MESSAGE } from '../types';

const initialState = {
  loading: false,
  //... [key]: { contact..., messages} conversations keyed by inboxId:convoId
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case GET_MESSAGES:
      return {
        ...state,
        loading: true,
      };
    case resolved(GET_MESSAGES): {
      const key = meta.inboxId + ':' + meta.convoId;
      const messages = state[key]?.messages || [];
      return {
        ...state,
        loading: false,
        [key]: {
          ...payload,
          messages:
            meta.offset === 0
              ? payload.messages
              : [...payload.messages, ...messages],
          hasMore: payload.messages.length > 0,
          offset: meta.offset,
          limit: meta.limit,
        },
      };
    }

    case rejected(GET_MESSAGES):
      return {
        ...state,
        loading: false,
      };
    case resolved(SEND_REPLY_MESSAGE): {
      const conv = state[meta.key];
      if (conv && payload) {
        return {
          ...state,
          [meta.key]: {
            ...conv,
            messages: [...conv.messages, payload],
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
};
